import { cn, Button, TooltipWrapper } from '@wellesley/ui'
import { X } from 'lucide-react'
import { FC } from 'react'

type CmpProps = {
  onClick: () => void
  className?: string
}

const ClearField: FC<CmpProps> = ({ onClick, className }) => {
  return (
    <div
      className={cn('right-xxs top-xl absolute', className)}
      data-testid="clear-field"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      <TooltipWrapper
        tooltipText="Clear"
        size="small"
        theme="dark"
        triggerClassname="w-full"
      >
        <Button
          variant="secondary"
          size="s"
          className="gap-xxxs p-xxs flex min-w-0"
          onClick={onClick}
          aria-label="Clear"
        >
          <X className="size-4" />
        </Button>
      </TooltipWrapper>
    </div>
  )
}

export default ClearField
